import { CONFIG, currentConfig } from "./config";
import { env } from "./env";

const makeApiUrl = (path: string) => {
  if (env.HEADLESS_MODE) {
    return CONFIG.staging.apiUrl + path;
  }

  return currentConfig.apiUrl + path;
};

export const Api = {
  Account: makeApiUrl("/account-service"),
  Template: makeApiUrl("/template-service"),
  Worker: makeApiUrl("/worker-service"),
  ModelGateway: makeApiUrl("/models"),
  ModelCatalog: makeApiUrl("/model-catalog-service"),
  Spaces: makeApiUrl("/spaces-service"),
  NeuralPluginsCatalog: makeApiUrl("/neural-plugins-catalog-service"),
  Chat: makeApiUrl("/chat-service"),
  Rental: makeApiUrl("/rental-service"),
  MCPServerGateway: makeApiUrl("/mcp-server-gateway-service"),
  RagService: makeApiUrl("/rag-service"),
};
